export default "__VITE_ASSET__b1ef529e__"